import React from 'react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import arrow from 'views/components/atoms/TableLink/images/arrow.png';
import { MAX_WIDTH } from 'views/constants';

const StyledLink = styled(Link)`
  max-width: ${MAX_WIDTH};
  margin: auto;
  padding: 10px 0;
  display: flex;
  text-decoration: none;
  background-image: url(${arrow});
  background-size: 8px 13px;
  background-position: right 18px center;
  background-repeat: no-repeat;
`;

interface TableLinkProps {
  to: string;
  onClick?(): void;
}

export const TableLink: React.FC<TableLinkProps> = ({
  to,
  onClick,
  children,
}) => (
  <StyledLink to={to} onClick={onClick}>
    {children}
  </StyledLink>
);
